class CollectionTabs extends HTMLElement {
  constructor() {
    super();
    this.tabButtons = this.querySelectorAll('[data-tab-button]');
    this.tabContents = this.querySelectorAll('[data-tab-content]');
    this.init();
  }

  init() {
    if (!this.tabButtons.length) return;

    this.setActiveTab(this.tabButtons[0].getAttribute('data-tab-button'));

    this.tabButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.setActiveTab(button.getAttribute('data-tab-button'));
      });

      button.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

        event.preventDefault();
        const buttons = Array.from(this.tabButtons);
        const currentIndex = buttons.indexOf(button);
        let targetIndex = currentIndex;

        if (event.key === 'ArrowRight') targetIndex = (currentIndex + 1) % buttons.length;
        if (event.key === 'ArrowLeft') targetIndex = (currentIndex - 1 + buttons.length) % buttons.length;
        if (event.key === 'Home') targetIndex = 0;
        if (event.key === 'End') targetIndex = buttons.length - 1;

        buttons[targetIndex]?.focus();
        this.setActiveTab(buttons[targetIndex]?.getAttribute('data-tab-button'));
      });
    });
  }

  setActiveTab(tabId) {
    this.tabButtons.forEach((button) => {
      const isActive = button.getAttribute('data-tab-button') === tabId;
      button.classList.toggle('active', isActive);
      button.setAttribute('aria-selected', String(isActive));
      button.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    this.tabContents.forEach((content) => {
      const isActive = content.getAttribute('data-tab-content') === tabId;
      content.classList.toggle('active', isActive);
      content.hidden = !isActive;
    });
  }
}

customElements.define('collection-tabs', CollectionTabs);